
    import { computed, defineComponent, PropType, ref } from 'vue';
    import { useAddressStore } from '@/store/address';

    import InputDropdown from '@/components/common/input-dropdown.vue'

    import { IDeliveryAddressDTO } from '@/types/shoppingCart';
    import { buildLocalization } from '@/util';

    export default defineComponent({
        name: 'AddressSelector',

        components: {
            InputDropdown
        },

        props: {
            id: { type: String as PropType<string>, required: true },
            width: { type: Number as PropType<number | null>, required: false, default: () => null }
        },

        emits: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            'update:modelValue': (value: IDeliveryAddressDTO | null) => true,
        },

        setup(props, { emit }) {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const addressStore = useAddressStore()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const selectedId = ref('')

            const publicData = { selectedId }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const { localize } = buildLocalization()
            const allAddresses = computed(() => addressStore.deliveryAddresses)
            const dataItems = computed(() => allAddresses.value
                ?.map((addr,index) => ({
                    id: index.toString(),
                    address: addr,
                    name: ToString(addr)
                }))
                ?? []
            )

            const computedData = { localize, allAddresses, dataItems }

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/
            function ToString(address: IDeliveryAddressDTO): string {
                return `${address.name1} / ${address.streetName} ${address.houseNumber} / ${address.zipCode} ${address.cityName}`
            }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            function onChange(id: string) {
                selectedId.value = id

                const result = dataItems.value                
                    ?.find(item => item.id == id)
                    ?.address                     
                    ?? null

                emit('update:modelValue', result)
            }

            const publicMethods = { onChange }

            return { ...publicData, ...computedData, ...publicMethods };
        }
    });
